import React from 'react'
import { Route, Switch } from 'react-router'
import ReportVehicleTraffic from './ReportVehicleTraffic'

const Components = props => (
    <Switch>
        <Route exact path={`${props.match.url}/:year?`} component={ReportVehicleTraffic} />
    </Switch>
)

export default Components
